import styled from "styled-components";

export const DivBeta = styled.div`
  background-color: #2c3955;
  color: white;
  font-size: 10px;
  border: none;
  border-radius: 8px;
  padding: 10px;
`;
